module.exports = __webpack_public_path__ + "static/img/bg_new_1.8e40980.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newImage/bg_new_1.png
// module id = JM/y
// module chunks = 3